angular.module('core')
  .controller('MilestoneCompletedLetterModalController', [
      '$scope',
      '$window',
      '$modalInstance',
      'milestoneCompletedLetterApi',
      'dblActivity',
      function ($scope,
                $window,
                $modalInstance,
                dblMilestoneCompletedLetterApi,
                dblActivity) {
          $scope.loadingModal = true;
          dblMilestoneCompletedLetterApi.getMilestoneCompletedLetter(dblActivity.studentId, dblActivity.milestoneTriggerLessonSlotId).then(function (data) {
              $scope.letter = data.letter;
              $scope.loadingModal = false;
          });
      }]);
